/**
 * "breathing" animation loader with Wikicasa symbol
 */
import { defineComponent } from "vue";
export default defineComponent({
  name: "ShimmerLoader",
  props: {
    containerClass: {
      type: String,
      default: ""
    },
    containerStyle: {
      type: String,
      default: ""
    },
    multipleRowText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cdn() {
      return window["_cdn"];
    }
  }
});